// 一覧表示系のページで使用する処理をまとめたもの
// mixinの挙動は継承ではなくマージなので留意すること

export default {
  data() {
    return {
      alertTitle: '', // アラートのタイトル
      alertDisplay: false, // アラートの表示切替
      errors: null, // エラーメッセージ
      alerts: '', // アラートの種類 success:成功 error:エラー
    }
  },
  methods: {
    /**
     * アラートをサクセスモードで開く
     */
    openSuccessAlert: function() {
      this.alerts = 'success'
      this.alertDisplay = true
    },
    /**
     * アラートをエラーモードで開く
     *
     * @param array errors エラーメッセージ
     */
    openErrorAlert: function(errors) {
      this.errors = errors.message === undefined ? errors : [errors]
      this.alerts = 'error'
      this.alertDisplay = true
    },
    /**
     * アラートを閉じる
     */
    closeAlert: function() {
      this.alertDisplay = false
    },
  },
}
